import { useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ViewCounter = () => {
  const [views, setViews] = useState(null);

  useEffect(() => {
    let active = true;
    const counted = sessionStorage.getItem('f100_viewed');
    const run = async () => {
      try {
        const response = await fetch(`${API}/views`, {
          method: counted ? 'GET' : 'POST',
          signal: AbortSignal.timeout(10000),
        });
        if (!response.ok) return;
        const data = await response.json();
        if (!counted) sessionStorage.setItem('f100_viewed', '1');
        if (active) setViews(data.views);
      } catch {
        /* contatore non critico: resta nascosto se non disponibile */
      }
    };
    run();
    return () => { active = false; };
  }, []);

  if (views === null) return null;

  return (
    <span className="footer-views" data-testid="footer-views">
      {views.toLocaleString('it-IT')} visite
    </span>
  );
};
